export const MP_STATUS_OPTIONS = [
  { label: 'Nouveau', value: 'new' },
  { label: 'Mappé', value: 'mapped' },
  { label: 'Envoi en cours', value: 'sending' },
  { label: 'Envoyé', value: 'sent' },
  { label: "Erreur d'envoi", value: 'send_error' },
  { label: 'Intégré', value: 'integrated' },
  { label: "Erreur d'intégration", value: 'integration_error' },
];

export const ACTION_TYPES = {
  REMOVE: 'remove',
  TRANSFORM: 'transform',
  BROADCAST: 'broadcast',
  REMOVE_ONE_FROM_CATEGORY: 'remove-one-from-category',
  PUBLISH_ONE: 'publish-one',
  TRANSFORM_ONE: 'transform-one',
};

export const MP_WITHOUT_BROADCAST = ['manomano'];
